module.exports = __webpack_public_path__ + "static/fabric-calendar-basic-31060e9949ac122fdaa5cecac08872e4.gif";